import w from "./index79.mjs";
import { formatDateISO8601 as c, isDateWithinInterval as L } from "@amenitiz/design-system";
import { generateMonths as m } from "./index146.mjs";
import { isBelowMinimumDays as x } from "./index147.mjs";
import { useState as f, useMemo as C, useCallback as r } from "react";
const U = m(/* @__PURE__ */ new Date(), []), W = () => {
  const [l, u] = f([]), [n, b] = f(null), [o, h] = f(U), D = o.length >= 24, d = C(() => (n == null ? void 0 : n.custom_unavailability_message) || null, [n]), v = (t, e, i) => {
    if (e) {
      const a = m(
        e,
        t,
        i
      );
      h((s) => [...s, ...a]);
    } else
      h(m(/* @__PURE__ */ new Date(), t, i));
    u((a) => [
      ...a,
      ...t
    ]);
  }, g = r(
    ({ startDate: t, endDate: e } = {}, i) => {
      const a = {
        ...t && { startDate: c(t) },
        ...e && { endDate: c(e) }
      };
      return w.getAvailabilities(a).then((s) => {
        b(s.limit_prior_to_arrival), v(
          s.availabilities,
          t,
          i
        );
      });
    },
    []
  ), A = () => {
    const t = o[o.length - 1], e = t.month + 1, i = e === 12 ? t.year + 1 : t.year;
    return new Date(i, e % 12);
  }, p = r(
    (t) => {
      if (!n)
        return !1;
      const {
        apply_minimum_hours_before_booking: e,
        days_limit_before_closing_booking: i,
        hour_limit_before_closing_booking: a
      } = n;
      return e ? x(
        t,
        i,
        new Date(a)
      ) : !1;
    },
    [n]
  ), M = (t, e) => !l.filter(
    (a) => L({
      date: new Date(a.date),
      start: t,
      end: e
    })
  ).some(
    (a) => !a.is_available
  ), y = (t) => t ? l.find(
    (e) => e.date === c(t)
  ) : null, _ = r(
    (t) => l.filter(
      (e) => new Date(e.date) > t
    ),
    [l]
  ), k = r(
    (t) => {
      const i = _(t).find(
        (s) => !s.is_available || s.closed
      );
      return i ? new Date(
        i.date.replace(/-/g, "/")
      ) : null;
    },
    [_]
  );
  return {
    months: o,
    setAvailabilities: u,
    setLimitPriorToArrival: b,
    fetchAvailabilities: g,
    updateAvailabilitiesAndMonths: v,
    findNextDateToLoad: A,
    isReachLimit: D,
    isWithinLimit: p,
    timeLimitCustomMessage: d,
    checkIfAvailable: M,
    getAvailabilityForDate: y,
    getFirstUnavailableDate: k
  };
};
export {
  W as useAvailabilities
};
